import { create } from "zustand";

const useStore = create((set) => ({
  currentCamera: "under",
  switchCamera: (cameraKey: string) =>
    set((state: any) => ({
      ...state,
      currentCamera: cameraKey,
    })),
}));

export default useStore;
